import ClientId from '~/constants/ClientId';
import type { RecommendedVehicle } from '~/contracts/common';

const SUGGESTED_FOR_YOU_PAGE_SIZE = 12;

type SuggestedForYouRequestInputs = {
  browserCookieId?: string;
  zip: string;
};

export type VehicleFromSuggestedForYou = Omit<
  RecommendedVehicle,
  'isFavorited' | 'vehicleUnlockDateTime'
> & {
  imageUrl?: string;
  vehicleUnlockDateTime: string;
};

export function buildSuggestedForYouRequest({
  browserCookieId,
  zip
}: SuggestedForYouRequestInputs) {
  return {
    browserCookieId,
    clientId: ClientId.HOME_UI,
    pagination: { page: 1, pageSize: SUGGESTED_FOR_YOU_PAGE_SIZE },
    zip5: zip
  };
}

export function mapSuggestedForYouResponse(
  vehicles: Array<VehicleFromSuggestedForYou>
): Array<RecommendedVehicle> {
  return vehicles.map(vehicle => ({ ...vehicle, isFavorited: false }));
}
